<template>
    <v-card
        :width="!$vuetify.breakpoint.mobile ? '450px' : '100vw'"
        :height="$vuetify.breakpoint.mobile ? '100dvh!important' : ''"
        class="rounded-lg mx-0 px-0 chat-window"
        :class="!this.$store.getters.getToken ? 'mobile' : ''"
    >
        <v-card-title class="my-0 py-0 elevation-2" :class="agent ? 'pl-10' : 'pl-5'" :style="`background-color: ${mainColor};`">
            <v-row align="center" class="my-0 py-0">
                <!-- <v-col :cols="agent ? 2 : 2" :lg="agent ? 2 : 2" class="my-0 py-3 mx-0 px-0" align="start">
                    <v-tooltip bottom v-if="!agent">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon color="white" v-bind="attrs" v-on="on" @click="setConversationMode()">
                                <v-icon color="white">
                                    mdi-swap-horizontal
                                </v-icon>
                            </v-btn>
                        </template>
                        <span v-if="!agent"> Μιλήστε με agent </span>
                        <span v-else> Μιλήστε με bot </span>
                    </v-tooltip>
                    <v-avatar>
                        <v-img
                            v-if="true"
                            :src="clientImage"
                            contain
                        />
                        <v-icon color="white" v-else>
                            {{ agent ? 'mdi-account' : 'mdi-robot-excited' }}
                        </v-icon>
                    </v-avatar>
                </v-col> -->
                <v-col class="py-2 my-0 mx-0 px-0" :class="{'ml-2': !$vuetify.breakpoint.mobile}" align="start">
                    <div class="white--text" :class="$vuetify.breakpoint.mobile ? 'title-mobile' : 'text-subtitle-1'" style="position: relative;">
                        {{ title }}  | eDimon Ψηφιακός Βοηθός
                        <span v-show="$vuetify.breakpoint.mobile" class="close-btn-control" style="position: absolute; right: 0px;" @click="close">
                            <v-icon>
                                mdi-close
                            </v-icon>
                        </span>
                    </div>
                    <div class="white--text text-subtitle-2" v-if="false">Customer Support</div>
                </v-col>
            </v-row>
            <v-row class="my-0 py-0" v-if="false">
                <v-col cols="3" lg="5" class="my-0 py-0">
                    <v-rating :value="4.5" color="white" dense half-increments readonly size="15"/>
                </v-col>
                <v-col cols="8" lg="7" align-self="start" class="mt-0 py-0 pl-5">
                    <span class="white--text text-subtitle-2">
                        4.5 (413)
                    </span>
                </v-col>
            </v-row>
        </v-card-title>
        <v-card-text v-if="this.$store.getters.getToken" ref="chat" class="pt-5 pr-2 chat-messages-content">
            <v-row no-gutters v-for="(element, index) in conversation" :key="index" :justify="element.actor_type === 'bot' || element.actor_type === 'agent' ? 'start' : 'end'" :mainColor="mainColor" class="mt-3">
                <quick-reply v-if="stringToObject(element).message.quick_replies" :agent="element.actor_type === 'bot'" :reply="stringToObject(element)" @prepareMessage="prepareMessage" :mainColor="mainColor" :isLastMessage="index == conversation.length - 1"/>
                <carousel-template v-else-if="stringToObject(element).message.attachment?.payload.template_type === 'generic'" :agent="element.actor_type === 'bot'" :reply="stringToObject(element)" @prepareMessage="prepareMessage" :mainColor="mainColor"/>
                <regular-button v-else-if="stringToObject(element).message.attachment?.payload.buttons" :agent="element.actor_type === 'bot'" :reply="stringToObject(element)" @prepareMessage="prepareMessage" :mainColor="mainColor"/>
                <media-template v-else-if="stringToObject(element).message.attachment?.type" :agent="element.actor_type === 'bot' || element.actor_type === 'agent'" :reply="stringToObject(element)" :mainColor="mainColor"/>
                <text-template v-else-if="stringToObject(element).message.text" :agent="element.actor_type === 'bot' || element.actor_type === 'agent'" :reply="stringToObject(element)" :mainColor="mainColor"/>
                <v-container class="py-0 my-0" v-if="index === conversation.length - 1">
                    <v-row no-gutters class="py-0 my-0">
                        <v-col cols="12" class="text-caption text-right" :align="element.actor_type === 'bot' || element.actor_type === 'agent' ? 'start' : 'end'"> {{ getDate(element.created_time) }} </v-col>
                    </v-row>
                </v-container>
            </v-row>
            <v-row no-gutters justify="start" v-if="loading">
                <typing-dots-animation :mainColor="mainColor"/>
            </v-row>
        </v-card-text>

        <v-card-actions v-show="this.$store.getters.getToken" class="elevation-1">
            <v-row no-gutters align="center" justify="center" class="my-0 pt-3">
                <v-col cols="10" sm="11" class="mx-0 px-0">
                    <v-textarea
                        v-model="text"
                        outlined
                        auto-grow
                        dense
                        :color="mainColor"
                        rows="1"
                        placeholder="Γράψτε εδώ την ερώτησή σας"
                        hide-details
                        style="max-height: 400px!important;"
                        @keyup.enter="sendMessage(text.slice(0, -1))"
                    />
                </v-col>
                <v-col align="center">
                    <div v-show="isBlank(text)">
                        <persistent-menu :menuData="menuData" @prepareMessage="prepareMessage" :mainColor="mainColor"/>
                    </div>
                    <v-btn v-show="!isBlank(text)"  icon dark :color="mainColor" @click="sendMessage(text)">
                        <v-icon>
                            mdi-send
                        </v-icon>
                    </v-btn>
                </v-col>
                <!-- <v-col cols="1" class="mx-0 my-0 py-0 px-0">
                    <v-btn icon dark :color="mainColor" @click="getHistory()">
                        <v-icon>
                            mdi-paperclip
                        </v-icon>
                    </v-btn>
                </v-col>
                <v-col cols="1" class="mx-0 my-0 py-0 px-0">
                    <v-btn icon dark :color="mainColor">
                        <v-icon>
                            mdi-emoticon
                        </v-icon>
                    </v-btn>
                </v-col> -->
                <v-col cols="12" align="center" class="pt-2">
                    <a href="https://mpass.gr/" target="blank_" class="remove-style">
                        <div class="d-inline-flex text-caption">
                            Powered by
                            <v-img width="50px" contain :src="require('@/assets/mpass-logo.png')" class="ml-1" />
                        </div>
                    </a>
                </v-col>
            </v-row>
        </v-card-actions>
        <v-card-text v-show="!this.$store.getters.getToken">
            <v-row no-gutters>
                <v-col cols=12 align="center" class="text-h5 pb-5 mt-3 pt-5">
                    <div>
                        <v-avatar style="border: 1px solid #b5b5b5;" class="mr-1">
                            <v-img
                                :src="clientImage"
                                contain
                                rounded
                            />
                        </v-avatar>
                        <span class="black--text">{{ welcomeTitle }}</span>
                    </div>
                    <div class="text-subtitle-2 font-weight-regular mt-5" v-html="welcomeMessage" />
                </v-col>
                <v-col cols=12 align="center">
                    <v-btn large @click="initConversation()" class="rounded-lg text-h6 white--text mt-5" :color="mainColor" style="text-transform: capitalize;">
                        {{ buttontitle }}
                    </v-btn>
                </v-col>
                <v-col cols=12 align="center">
                    <div class="text-caption mt-5" style="height: 60px;align-content: end;">
                        Powered by
                        <a href="https://mpass.gr/" target="_blank">
                            <v-avatar>
                                    <v-img
                                        :src="require('@/assets/mpass-logo.png')"
                                        contain
                                    />
                            </v-avatar>
                        </a>
                    </div>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
    import quickReply from '@/components/messageTemplates/QuickReplyButtons'
    import regularButton from '@/components/messageTemplates/RegularButtons'
    import textTemplate from '@/components/messageTemplates/TextTemplate'
    import mediaTemplate from '@/components/messageTemplates/MediaTemplate'
    import carouselTemplate from '@/components/messageTemplates/CarouselTemplate'
    import persistentMenu from '@/components/webChatComponents/PersistentMenu'
    import typingDotsAnimation from '@/components/webChatComponents/TypingDotsAnimation'
    import userService from '@/services/user.js'
    import momentTimezone from 'moment-timezone'

    export default {
        components: { quickReply, regularButton, textTemplate, mediaTemplate, carouselTemplate, persistentMenu, typingDotsAnimation },
        props: {
            clientImage: {
                type: String,
                default: null
            },
            poweredBy: {
                type: Boolean,
                default: false
            },
            mainColor: {
                type: String,
                default: null
            },
            title: {
                type: String,
                default: ''
            },
            welcomeMessage: {
                type: String,
                default: ''
            },
            welcomeTitle: {
                type: String,
                default: ''
            },
            buttontitle: {
                type: String,
                default: ''
            }
        },
        data: () => ({
            // isConnected: false,
            socketMessage: '',
            text: '',
            reply: {message: { agent: false }},
            conversation: [],
            agent: false,
            loading: false,
            menuData: {},
            getStarted: null,
            // connectErrorCount: 0
        }),
        sockets: {
            'sync-message'(data) {
                this.conversation.push(data)
            },
            'get-bot-message'(data) {
                this.conversation.push(data)
            },
            'get-agent-message'(data) {
                data.message_parts.forEach(message_part => {
                    let message =  JSON.parse(JSON.stringify(data))
                    message.message_parts = [message_part]
                    this.conversation.push(message)
                })
            },
            'resolve-conversation'() {
                this.resetConversation()
            },
            'disconnect'(data) {
                // this.isConnected = false;
                console.log('disconnect', data)
            },
            'connect_error'(data, d2) {
                console.log('error', data, data.message, d2)
                // if(this.$store.getters.getToken && this.connectErrorCount > 1) {
                //     this.resetToken()
                //     this.connectErrorCount = 0
                //     this.loading = false
                // }
                // this.connectErrorCount += 1
            },
            'server-error'() {
                this.resetToken()
                this.loading = false
            },
            // Fired when the server sends something on the "messageChannel" channel.
            messageChannel(data) {
                this.socketMessage = data
            }
        },
        updated() {
            this.scrollToCurrent()
        },
        async created() {
            this.getPersistentMenuAndGetStarted()
            const userToken = this.$store.getters.getToken
            if (userToken) {
                let errorStatus = null
                try {
                    await userService.currentUser()
                }
                catch (error) {
                    // console.log(error)
                    errorStatus = error.response.status
                }
                if (errorStatus >= 400 && errorStatus < 500) {
                    this.resetToken()
                }
                else {
                    this.startPolling(userToken)
                    this.getHistory()
                    this.agent = this.$store.getters.getAgent
                }
            }
        },
        methods: {
            initConversation(sendMessage = true) {
                userService.login()
                    .then(resp => {
                        const userToken = resp.data.token
                        this.getGetStarted()
                        this.$store.dispatch('setToken', userToken)
                        this.startPolling(userToken)
                        if(sendMessage)
                            this.sendMessage(this.getStarted.template['get_started'].payload, false)
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            async getPersistentMenuAndGetStarted() {
                const [persistentMenu, getStarted] = await Promise.all([
                    userService.getPersistentMenu(),
                    userService.getGetStarted(),
                ])
                this.menuData = persistentMenu
                this.getStarted = getStarted?.data
            },
            getGetStarted() {
                userService.getGetStarted().then(resp => {
                    this.getStarted = resp.data
                })
            },
            startPolling(userToken) {
                this.$socket.io.opts.transportOptions.polling.extraHeaders.jwt = userToken
                this.$socket.connect()
            },
            resetConversation() {
                this.$store.dispatch('clearConversation')
                this.conversation = []
            },
            resetToken() {
                this.resetConversation()
                this.$store.dispatch('setToken', null)
            },
            setConversationMode() {
                this.agent = !this.agent
                this.$store.dispatch('setAgent', this.agent)
                if (this.agent === true) {
                    this.$socket.emit('set-conversation-mode', { "mode": "agent" })
                }
            },
            getDate(date) {
                const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
                return momentTimezone(date).tz('Europe/Athens').locale(timezone).format('D/M/y, HH:mm').toString()
            },
            scrollToCurrent() {
                if (this.$refs.chat) {
                    this.$refs.chat.scrollTop = this.$refs.chat.scrollHeight
                }
            },
            stringToObject(element) {
                let reply = ''
                if (element.actor_type !== 'bot') {
                    if (element.message_parts[0].text) {
                        reply = {
                            message: {
                                text: element.message_parts[0].text.content
                            }
                        }
                    } else if (element.message_parts[0].image) {
                        reply = {
                            message: {
                                "attachment":
                                {
                                    "type":"image", 
                                    "payload":
                                    {
                                        "url": element.message_parts[0].image.url
                                    }
                                }
                            }
                        }
                    }
                } else {
                    reply = JSON.parse(element.message_parts[0].text.content)
                }
                return reply
            },
            getHistory() {
                this.$socket.emit('get-history', (data) => {
                    data.forEach(element => {
                        element.message_parts.forEach(message_part => {
                            let message =  JSON.parse(JSON.stringify(element))
                            message.message_parts = [message_part]
                            this.conversation.push(message)
                        })
                    })
                })
            },
            prepareMessage(message) {
                this.sendMessage(message)
            },
            isBlank(str) {
                return (!str || /^\s*$/.test(str))
            },
            sendMessage(object, pushToConversation = true) {
                let text, freshchatAgentText, convText
                if (typeof object === 'object' && !Array.isArray(object) && object !== null) {
                    text = object.text
                    freshchatAgentText = object.freshchatAgentText || null
                    convText = freshchatAgentText
                } else {
                    text = object
                    freshchatAgentText = null
                    convText = text
                }

                if (this.isBlank(text)) {
                    return
                }
                this.loading = true
                if(pushToConversation)
                    this.conversation.push(
                        {
                            'message_parts': [{ text: { content: convText } }]
                        }
                    )
                this.$socket.emit('send-message', 
                {
                    "wid": 1,
                    "message_parts":
                    [
                        {
                            "text":  text,
                            "freshchatAgentText": freshchatAgentText
                        }
                    ]
                }, () => { 
                    // this.reply = reply
                    // if(!this.reply.message) {
                    //     this.reply = {
                    //         message: {
                    //             text: reply.message_parts[0].text.content
                    //         }
                    //     }
                    // }
                    // this.conversation.push(reply)
                    this.loading = false
                })
                this.text = ''
            },
            close() {
                this.$emit('close')
            }
        },
    }
</script>

<style>
a:visited, a {
    color: rgba(73, 73, 73, 0.6);
    text-decoration: none;
}
.chat-messages-content {
    overscroll-behavior: contain;
}
.v-menu__content {
    border: 2px solid v-bind(mainColor) !important;
}
.v-application--is-ltr .v-textarea.v-text-field--enclosed .v-text-field__slot textarea {
    padding-left: 12px;
}
.v-text-field.v-text-field--enclosed .v-text-field__details, .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)>.v-input__control>.v-input__slot {
    padding: 0 !important;
}
.remove-style {
    text-decoration: none;
}
.v-card {
  display: flex !important;
  flex-direction: column;
  padding: 0 !important;
}

.v-card__text {
  flex-grow: 1;
  overflow: auto;
  padding: 0 !important;
}
.bubble-size {
    max-width: 70%;
    word-wrap: break-word;
}

.bubble-text {
    white-space: pre-line;
}
.chat-window {
    height: 80vh;
}
.chat-window.mobile {
    height: 50vh;
}

.title-mobile {
    font-size: .7em;
}

@media only screen and (max-height: 700px) {
  .chat-window.mobile {
    height: 60vh!important;
  }
}

@media only screen and (max-width: 344px) {
  .title-mobile {
    font-size: .65em;
  }
}
</style>

<style scoped>
div.row.no-gutters.justify-start .text-caption, div.row.no-gutters.justify-end .text-caption {
    opacity: 0;
}
div.row.no-gutters.justify-start:hover .text-caption, div.row.no-gutters.justify-end:hover .text-caption {
    opacity: 1!important;
}
</style>

<style scoped src="../../node_modules/vuetify/dist/vuetify.min.css">
</style>

<style scoped src="@mdi/font/css/materialdesignicons.css">
</style>
